import Vue from 'vue';
import {UPDATE_GEO_DATA} from '../mutationTypes';

export default {
  [UPDATE_GEO_DATA](state, data) {
    Object.assign(state, data);
    Vue.$storage.set('geo', data);
  },
};
